import React from 'react';
import ContactButton from './ContactButton';

const WriteUsCard = ({ card }) => {
  return (
    <div className="section-grid">
      {card.map(({ key, title, icon, info, button, link, buttonLabel }) => (
        <div key={key} className="item shadow-blue-4 rounded-16">
          {icon}
          <h3 className="text-title my-12">{title}</h3>
          <div className="wrapper-content">
            {info}
            <ContactButton buttonId={button} link={link} buttonLabel={buttonLabel} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default WriteUsCard;
